export default defineNuxtPlugin({
  name: 'currency',
  dependsOn: ['site'],
  async setup() {
    // Finish validation before route middleware, API requests or page caches
    // can use the device's currency preference.
    await useCurrencyStore().fetch()
  },
})
